import React from 'react';
import ReportIcon from './ReportIcons';

const deltaText = (delta) => `${delta > 0 ? '+' : ''}${delta}`;

function ChangeBadge({ delta }) {
  if (delta < 0) {
    return <span className="v5r-compare-delta down">本次未形成稳定提升</span>;
  }
  const tone = delta > 0 ? 'up' : delta < 0 ? 'down' : 'flat';
  const label = delta > 0 ? '提升' : '持平';
  return <span className={`v5r-compare-delta ${tone}`}>{label} {deltaText(delta)} 分</span>;
}

function ScoreJourney({ item, label }) {
  if (!item) return null;
  return (
    <div className="v5r-compare-journey">
      <div className="v5r-compare-journey-head">
        <strong>{label}</strong>
        <ChangeBadge delta={item.delta} />
      </div>
      <div className="v5r-compare-scores" aria-label={`${label}复测前后分数`}>
        <span><small>初测</small><b>{item.before}</b></span>
        <ReportIcon name="arrow-right" size={18} />
        <span><small>复测</small><b>{item.after}</b></span>
      </div>
    </div>
  );
}

export default function RetestComparison({ comparison, learningEntry, reportActions }) {
  if (!comparison?.available) return null;
  const learningUrl = typeof learningEntry?.homepage_url === 'string'
    ? learningEntry.homepage_url.trim()
    : '';
  const showLearningAction = learningEntry?.available
    && reportActions?.learning_allowed !== false
    && /^https?:\/\//i.test(learningUrl);
  const targeted = comparison.scope === 'targeted';
  const title = '复测结果';
  const description = targeted
    ? '展示本轮覆盖能力的初测与复测分数变化。'
    : '展示 AI 领导力总分及五力的初测与复测分数变化。';

  return (
    <section id="v5r-sec-comparison" className="v5r-compare" aria-labelledby="v5r-compare-title">
      <div className="v5r-compare-head">
        <div>
          <span className="v5r-section-kicker">正式复测结果</span>
          <h2 id="v5r-compare-title">{title}</h2>
          <p>{description}</p>
        </div>
        {showLearningAction && (
          <a className="v5r-learning-link" href={learningUrl}>
            <ReportIcon name="book-open" size={16} />
            继续学习
          </a>
        )}
      </div>

      {!targeted && <ScoreJourney item={comparison.overall} label="AI 领导力总分" />}

      <div className="v5r-compare-grid">
        {(comparison.abilities || []).map((item) => (
          <ScoreJourney key={item.code} item={item} label={item.name} />
        ))}
      </div>
      <p className="v5r-compare-note">
        分数变化用于复盘与效果展示；是否由学习直接造成，仍需结合学习过程和实际工作表现判断。
      </p>
    </section>
  );
}
